import { render, staticRenderFns } from "./EmailAttachments.vue?vue&type=template&id=f35a67d6"
import script from "./EmailAttachments.vue?vue&type=script&lang=js"
export * from "./EmailAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f35a67d6')) {
      api.createRecord('f35a67d6', component.options)
    } else {
      api.reload('f35a67d6', component.options)
    }
    module.hot.accept("./EmailAttachments.vue?vue&type=template&id=f35a67d6", function () {
      api.rerender('f35a67d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/EmailAttachments.vue"
export default component.exports